<template>
  <div>
    <hr v-if="type === 'line'" :style="lineStyles" />
    <div v-if="type === 'pill'">
      <div class="line-through">
        <div class="pill shadow center-children">
          <span class="value-label">{{ text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SSeparator",
  props: {
    placement: { Type: String, default: "horizontal" },
    color: { Type: String, default: "#000000" },
    type: { default: "line" },
    text: { default: "-" },
  },
  computed: {
    lineStyles() {
      var fcolor, lwidth, lheigth;
      if (
        this.color.indexOf("#") === 0 ||
        (this.color.localeCompare("r") == 0 &&
          this.color.localeCompare("-") === -1)
      ) {
        fcolor = this.color;
      } else {
        fcolor = "var(--" + this.color + ")";
      }
      if (this.placement.localeCompare("horizontal") == 0) {
        lwidth = "100%";
        lheigth = "1px";
      }
      if (this.placement.localeCompare("vertical") == 0) {
        lwidth = "1px";
        lheigth = "100vh";
      }
      return {
        border: "1px solid " + fcolor,
        width: lwidth,
        height: lheigth,
        "background-color": fcolor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.line-through {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.line-through:before {
  content: "";
  position: absolute;
  border-bottom: 1px solid var(--very-light-pink);
  height: 100%;
  width: 100%;
}

.pill {
  width: 150px;
  border-radius: 16px;
  height: 32px;
  padding: 3px;
  // border: 1px solid #e1e1e1;
  transform: translateY(50%);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  z-index: 0;
}

.center-children {
  justify-content: center;
  display: flex;
  align-items: center;
}

.shadow {
  -webkit-box-shadow: 0 0 20px var(--very-light-pink);
  box-shadow: 0 0 20px var(--very-light-pink);
}
</style>
